import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from '@tsin-env/environment';
import { ChangeRequestInput, IChangeRequest, IChangeRequestApprovalRes } from './interface';

const API_URI = `${environment.apiBaseUrl}/request-form`;
@Injectable({
    providedIn: 'root'
})
export class ChangeRequetService {
    http: HttpClient = inject(HttpClient);

    getRequests(queryParams: { formTitle: string }) {
        return this.http.get<IChangeRequest[]>(API_URI, { params: queryParams });
    }

    createChangeRequest(input: ChangeRequestInput) {
        return this.http.post<IChangeRequest>(`${API_URI}/create/change-request-form`, input);
    }

    getSingle(id: string) {
        return this.http.get<IChangeRequest>(`${API_URI}/single/${id}`);
    }

    getByUser(input: { id: string; query: string }) {
        return this.http.get<IChangeRequest[]>(
            `${API_URI}/user/${input.id}?formTitle=${input.query}`
        );
    }

    getApproverRequests(input: { id: string; query: string }) {
        return this.http.get<IChangeRequestApprovalRes[]>(
            `${API_URI}/assigned-requests/${input.id}?formTitle=${input.query}`
        );
    }
}
